import Playground from "./components/Playground"

const App: React.FC = () => {
  return (
    <div>
      <Playground />
    </div>
  )
}

export default App
